import discardWeatherOption from './data/mutators/discardWeatherOption';
import saveWeatherOption from './orchestration/saveWeatherOption';
import WeatherFull from './view/WeatherFull';
import isWeatherOptionDirty from './utils/isWeatherOptionDirty';
import { Option } from 'owa-options-core';
import * as React from 'react';

let WeatherOption: Option = {
    key: 'weatherOption',
    titleStringKey: 'optionTitle_weather',
    searchTermsStringKey: 'optionTitle_weather',
    fullOptionFormSettings: {
        render: () => <WeatherFull />,
        isDirty: isWeatherOptionDirty,
        onSave: saveWeatherOption,
        onDiscard: discardWeatherOption,
    },
    allowedOptionKeys: ['Weather'],
};

export default WeatherOption;
